module.exports = __webpack_public_path__ + "static/img/news-icon2.a7bea81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news-icon2.png
// module id = FE78
// module chunks = 1